var _defs, _g, _path, _g2, _g3, _path2, _g4, _g5, _path3, _path4, _g6, _g7, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperPlanes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 201,
    height: 201,
    viewBox: "0 0 201 201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12643",
    "data-name": "Rectangle 12643",
    width: 201,
    height: 201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12642",
    "data-name": "Rectangle 12642",
    width: 185.012,
    height: 109.365,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12630",
    "data-name": "Rectangle 12630",
    width: 83.428,
    height: 28.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12632",
    "data-name": "Rectangle 12632",
    width: 13.832,
    height: 15.994,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12633",
    "data-name": "Rectangle 12633",
    width: 50.143,
    height: 48.847,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12635",
    "data-name": "Rectangle 12635",
    width: 60.95,
    height: 51.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12638",
    "data-name": "Rectangle 12638",
    width: 60.951,
    height: 51.44,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "paper_planes",
    "data-name": "paper planes",
    transform: "translate(100.5 100.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274923",
    "data-name": "Group 274923",
    transform: "translate(-100.5 -100.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274922",
    "data-name": "Group 274922",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "planes",
    transform: "translate(7.994 45.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274921",
    "data-name": "Group 274921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274920",
    "data-name": "Group 274920",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274919",
    "data-name": "Group 274919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274918",
    "data-name": "Group 274918",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274893",
    "data-name": "Group 274893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274892",
    "data-name": "Group 274892",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274891",
    "data-name": "Group 274891",
    transform: "translate(101.584)",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274890",
    "data-name": "Group 274890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274889",
    "data-name": "Group 274889",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37838",
    "data-name": "Path 37838",
    d: "M216.348,106.456l22.478,12.968,60.951-28.962Z",
    transform: "translate(-216.348 -90.462)",
    fill: "#ffe96e"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37839",
    "data-name": "Path 37839",
    d: "M260.728,119.424l4.755,22.479,6.052-15.994,50.144-35.446Z",
    transform: "translate(-136.666 -90.462)",
    fill: "#3c71fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_274901",
    "data-name": "Group 274901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274900",
    "data-name": "Group 274900",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274896",
    "data-name": "Group 274896",
    transform: "translate(128.817 35.446)",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274895",
    "data-name": "Group 274895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274894",
    "data-name": "Group 274894",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37840",
    "data-name": "Path 37840",
    d: "M270.117,176.44l13.832-11.672-7.781-4.323Z",
    transform: "translate(-270.117 -160.446)",
    fill: "#141d47"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_274899",
    "data-name": "Group 274899",
    transform: "translate(134.869 0.001)",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274898",
    "data-name": "Group 274898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274897",
    "data-name": "Group 274897",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37841",
    "data-name": "Path 37841",
    d: "M282.065,125.909l22.478,13.4,27.665-48.846Z",
    transform: "translate(-282.065 -90.463)",
    fill: "#ffe96e"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37842",
    "data-name": "Path 37842",
    d: "M15.783,145.715l22.478,12.968,60.95-28.962Z",
    transform: "translate(-15.783 -109.836)",
    fill: "#ffe96e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_274909",
    "data-name": "Group 274909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274908",
    "data-name": "Group 274908",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274904",
    "data-name": "Group 274904",
    transform: "translate(22.478 19.884)",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274903",
    "data-name": "Group 274903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274902",
    "data-name": "Group 274902",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37843",
    "data-name": "Path 37843",
    d: "M60.163,158.683l4.755,22.478,6.052-15.994,50.144-35.446Z",
    transform: "translate(-60.163 -129.721)",
    fill: "#3d72fc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_274907",
    "data-name": "Group 274907",
    transform: "translate(27.233 55.331)",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274906",
    "data-name": "Group 274906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274905",
    "data-name": "Group 274905",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37844",
    "data-name": "Path 37844",
    d: "M69.551,215.7l13.832-11.671L75.6,199.705Z",
    transform: "translate(-69.551 -199.705)",
    fill: "#121b45"
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37845",
    "data-name": "Path 37845",
    d: "M81.5,165.167l22.478,13.4,27.665-48.847Z",
    transform: "translate(-48.215 -109.837)",
    fill: "#ffe96e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37846",
    "data-name": "Path 37846",
    d: "M148.924,220.82,171.4,233.788l60.951-28.962Z",
    transform: "translate(-81.49 -146.902)",
    fill: "#ffe96e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_274917",
    "data-name": "Group 274917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274916",
    "data-name": "Group 274916",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274912",
    "data-name": "Group 274912",
    transform: "translate(89.912 57.924)",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274911",
    "data-name": "Group 274911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274910",
    "data-name": "Group 274910",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37847",
    "data-name": "Path 37847",
    d: "M193.3,233.788l4.755,22.478,6.052-15.993,50.144-35.447Z",
    transform: "translate(-193.304 -204.826)",
    fill: "#3d72fc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_274915",
    "data-name": "Group 274915",
    transform: "translate(94.668 93.371)",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274914",
    "data-name": "Group 274914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274913",
    "data-name": "Group 274913",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37848",
    "data-name": "Path 37848",
    d: "M202.692,290.8l13.833-11.672-7.781-4.323Z",
    transform: "translate(-202.693 -274.81)",
    fill: "#161e47"
  }))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37849",
    "data-name": "Path 37849",
    d: "M214.641,240.273l22.478,13.4,27.665-48.846Z",
    transform: "translate(-113.922 -146.903)",
    fill: "#ffe96e"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlanes);
export default __webpack_public_path__ + "static/media/paper_planes.6e9c57220009126479647007ba5a3cd5.svg";
export { ForwardRef as ReactComponent };